export type ApplinksError = {
	type: string;
	category: string;
};

export type ListOfApplinksErrors = {
	[key: string]: ApplinksError;
};

// Defining all possible error types
export const ERRORS: ListOfApplinksErrors = {
	// Network errors
	CONNECTION_REFUSED: { type: 'CONNECTION_REFUSED', category: 'NETWORK_ERROR' },
	UNKNOWN_HOST: { type: 'UNKNOWN_HOST', category: 'NETWORK_ERROR' },
	SSL_UNTRUSTED: { type: 'SSL_UNTRUSTED', category: 'NETWORK_ERROR' },
	SSL_HOSTNAME_UNMATCHED: { type: 'SSL_HOSTNAME_UNMATCHED', category: 'NETWORK_ERROR' },
	SSL_UNMATCHED: { type: 'SSL_UNMATCHED', category: 'NETWORK_ERROR' },
	OAUTH_PROBLEM: { type: 'OAUTH_PROBLEM', category: 'NETWORK_ERROR' },
	OAUTH_TIMESTAMP_REFUSED: { type: 'OAUTH_TIMESTAMP_REFUSED', category: 'NETWORK_ERROR' },
	OAUTH_SIGNATURE_INVALID: { type: 'OAUTH_SIGNATURE_INVALID', category: 'NETWORK_ERROR' },
	UNEXPECTED_RESPONSE: { type: 'UNEXPECTED_RESPONSE', category: 'NETWORK_ERROR' },
	UNEXPECTED_RESPONSE_STATUS: { type: 'UNEXPECTED_RESPONSE_STATUS', category: 'NETWORK_ERROR' },

	// Configuration state errors
	CREATION_FAILED: { type: 'CREATION_FAILED', category: 'CREATION_FAILED' },
	CONFIGURATION_INCOMPLETE: {
		type: 'CONFIGURATION_INCOMPLETE',
		category: 'CONFIGURATION_INCOMPLETE',
	},
	IN_PROGRESS: { type: 'IN_PROGRESS', category: 'IN_PROGRESS' },
	SUBMISSION_FAILED: { type: 'SUBMISSION_FAILED', category: 'SUBMISSION_FAILED' },
	CONFIGURATION_COMPLETE: { type: 'CONFIGURATION_COMPLETE', category: 'CONFIGURATION_COMPLETE' },

	// Configuration errors
	AUTH_LEVEL_MISMATCH: { type: 'AUTH_LEVEL_MISMATCH', category: 'CONFIG_ERROR' },
	NO_REMOTE_APPLINK: { type: 'NO_REMOTE_APPLINK', category: 'CONFIG_ERROR' },

	// Access errors
	LOCAL_AUTH_TOKEN_REQUIRED: { type: 'LOCAL_AUTH_TOKEN_REQUIRED', category: 'ACCESS_ERROR' },
	REMOTE_AUTH_TOKEN_REQUIRED: { type: 'REMOTE_AUTH_TOKEN_REQUIRED', category: 'ACCESS_ERROR' },
	INSUFFICIENT_REMOTE_PERMISSION: {
		type: 'INSUFFICIENT_REMOTE_PERMISSION',
		category: 'ACCESS_ERROR',
	},

	// Incompatibility errors
	REMOTE_VERSION_INCOMPATIBLE: { type: 'REMOTE_VERSION_INCOMPATIBLE', category: 'INCOMPATIBLE' },
	NO_OUTGOING_AUTH: { type: 'NO_OUTGOING_AUTH', category: 'INCOMPATIBLE' },

	// Non-Atlassian errors
	GENERIC_LINK: { type: 'GENERIC_LINK', category: 'NON_ATLASSIAN' },
	NON_ATLASSIAN: { type: 'NON_ATLASSIAN', category: 'NON_ATLASSIAN' },

	// System errors
	SYSTEM_LINK: { type: 'SYSTEM_LINK', category: 'SYSTEM' },

	// Deprecated functionality errors
	AUTH_LEVEL_UNSUPPORTED: { type: 'AUTH_LEVEL_UNSUPPORTED', category: 'DEPRECATED' },
	LEGACY_UPDATE: { type: 'LEGACY_UPDATE', category: 'DEPRECATED' },
	LEGACY_REMOVAL: { type: 'LEGACY_REMOVAL', category: 'DEPRECATED' },
	MANUAL_LEGACY_UPDATE: { type: 'MANUAL_LEGACY_UPDATE', category: 'DEPRECATED' },
	MANUAL_LEGACY_REMOVAL: { type: 'MANUAL_LEGACY_REMOVAL', category: 'DEPRECATED' },

	// Unknown errors
	UNKNOWN: { type: 'UNKNOWN', category: 'UNKNOWN' },
};
